import { useEffect } from "react";

const BASE_TITLE = "Result by Numero";

/**
 * Custom hook to dynamically update document.title and meta description.
 */
export function usePageTitle(title: string, description?: string) {
  useEffect(() => {
    const fullTitle = title.includes(BASE_TITLE) ? title : `${title} | ${BASE_TITLE}`;
    document.title = fullTitle;

    if (description) {
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.setAttribute("content", description);
      }
    }
  }, [title, description]);
}

export default usePageTitle;
